import {MarketingMaterialService} from "../services/MarketingMaterialService";

export class MarketingMaterialItem{

    /////[ Constructor ]////////////////////////////////////////////////////////////////////////////

    constructor(companyId) {

        if (!companyId){
            throw new Error('[e873237] CompanyId is expected but is undefined');
        }

        // Properties    
        this.name = '';
        this.description = '';
        this.fileId = '';
        this.isActive = true;

        // Fields
        this._companyId = companyId;
        this._isUploaded = false;
        this._itemId = '';
        this._uri = '';
        this._fileName = '';
        this._mimeType = '';        
        this._orderIndex = 999;
        this.orderIndexOrig = 999;
    }


    /////[ Properties - Immutable ]/////////////////////////////////////////////////////////////////

    get companyId() { return this._companyId; }
    set companyId(value) { /*immutable*/ }
    get IsUploaded() { return this._isUploaded; }
    set IsUploaded(value) { /*immutable*/ }
    get uri() { return this.uri; }
    set uri(value) { /*immutable*/ }
    get fileName() { return this._fileName; }
    set fileName(value) { /*immutable*/ }
    get mimeType() { return this._mimeType; }
    set mimeType(value) { /*immutable*/ }
    get itemId() { return this._itemId; }
    set itemId(value) { /*immutable*/ }


    /////[ Properties ]/////////////////////////////////////////////////////////////////////////////

    get orderIndex() { return this._orderIndex; }
    set orderIndex(value) {
        // Capture the original value if it is being set.  A value of 999 implies the originalValue
        // has not been set.  Thus, if the originalValue is 999 and value is not 999 then the
        // implication is the original value is being set and should be captured.
        if (value != 999 && this.orderIndexOrig === 999) {
            this.orderIndexOrig = value;
        }
        this._orderIndex = value;
    }

    /**
     * Gets a flag indicating whether the order index has changed
     */
    get isOrderIndexChanged() {
        return this.orderIndexOrig != this.orderIndex
    }
    

    /////[ Methods ]////////////////////////////////////////////////////////////////////////////////

    setFile(itemId, uri, filename, mimeType){
        this._itemId = itemId;
        this._uri = uri;
        this._fileName = filename;
        this._mimeType = mimeType;
        this._isUploaded = true;
    }

    activate(auth){
        let vm = this;
        return new Promise((resolve, reject) => {
            try {
                let service = new MarketingMaterialService(auth);
                service.changeActiveStatus(vm.itemId, true).then(data => {
                        vm.isActive = true;
                        resolve();
                    }
                ).catch(error => {
                    console.error('[e006908] Error when submitting activate post to server.');
                    if (error) {
                        console.error(error);
                    }
                    reject(error);
                });
            }
            catch(err){
                console.error('[e935634] Internal Exception');
                if (err){
                    console.error(err);
                }

                reject(err);
            }
        });
    }

    deactivate(auth) {

        if (!auth){
            throw new Error('[e677657] auth argument is required')
        }

        console.debug('[d400303] deactivating item');
        let vm = this;
        return new Promise((resolve, reject) => {
            try {
                let service = new MarketingMaterialService(auth);
                service.changeActiveStatus(vm.itemId, false).then(data => {
                        vm.isActive = false;
                        resolve();
                    }
                ).catch(error => {
                    console.error('[e406081] Error when submitting deactivate post to server.');
                    if (error) {
                        console.error(error);
                    }
                    reject(error);
                });
            }
            catch(err){
                console.error('[e9314585] Internal Exception');
                if (err){
                    console.error(err);
                }

                reject(err);
            }
        });
    }

    delete(auth){

        let vm = this;
        return new Promise((resolve, reject) => {

            let service = new MarketingMaterialService(auth);
            service.deleteItem(this.itemId).then(data => {
                let itemId = vm.itemId;
                resolve(itemId);
                vm.__resetInstance();
            }).catch(error => {
                console.error('[e012927] failure to delete item on the server');
                if (error){
                    console.error(error);
                }
            });
        });
    }

    save(auth){
        let service = new MarketingMaterialService(auth);
        return service.save(this);
    }

    getDownloadUrl(auth){
        let service = new MarketingMaterialService(auth);
        return service.getDownloadUrl(this.itemId);
    }

    /**
     * Returns true if a file exists in the server,
     * false otherwise.
     * @param auth
     * @returns {Promise<boolean>}
     */
    existsFile(auth){
        let service = new MarketingMaterialService(auth);
        return service.existFile(this.itemId);
    }

    __resetInstance(){
        this.name = '';
        this.description = '';
        this.fileId = '';
        this.isActive = true;
        this._uri = '';
        this._fileName = '';
        this._mimeType = '';
        this._isUploaded = false;
    }

    static getItemsForCompany(auth, companyId){
        let service = new MarketingMaterialService(auth);
        return service.getItems(companyId);
    }
}